module.exports = __webpack_public_path__ + "static/img/jzgl_p1.7dec726.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/jzgl_p1.png
// module id = z8BK
// module chunks = 19